// ── Types ─────────────────────────────────────────────────────────────────────

export interface DashboardStats {
  totalJobs: number;
  totalJobSeekers: number;
  totalEmployers: number;
  activeJobs: number;
  newJobSeekers: number;
  newEmployers: number;
}

// ── Action types ──────────────────────────────────────────────────────────────

export const FETCH_DASHBOARD_STATS_REQUEST = 'FETCH_DASHBOARD_STATS_REQUEST';
export const FETCH_DASHBOARD_STATS_SUCCESS = 'FETCH_DASHBOARD_STATS_SUCCESS';
export const FETCH_DASHBOARD_STATS_FAILURE = 'FETCH_DASHBOARD_STATS_FAILURE';

export type FetchDashboardStatsRequest = {
  type: typeof FETCH_DASHBOARD_STATS_REQUEST;
}

export type FetchDashboardStatsSuccess = {
  type: typeof FETCH_DASHBOARD_STATS_SUCCESS;
  payload: DashboardStats;
}

export type FetchDashboardStatsFailure = {
  type: typeof FETCH_DASHBOARD_STATS_FAILURE;
  payload: string;
}

export type DashboardAction =
  | FetchDashboardStatsRequest
  | FetchDashboardStatsSuccess
  | FetchDashboardStatsFailure;

// ── Action creators ───────────────────────────────────────────────────────────

export const fetchDashboardStatsRequest = (): FetchDashboardStatsRequest => ({
  type: FETCH_DASHBOARD_STATS_REQUEST,
});

export const fetchDashboardStatsSuccess = (
  payload: DashboardStats
): FetchDashboardStatsSuccess => ({
  type: FETCH_DASHBOARD_STATS_SUCCESS,
  payload,
});

export const fetchDashboardStatsFailure = (
  payload: string
): FetchDashboardStatsFailure => ({
  type: FETCH_DASHBOARD_STATS_FAILURE,
  payload,
});
